module.exports = __webpack_public_path__ + "img/chrome.626ac9f1.png";